import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Access isVerified from the Redux store
  const verified = useSelector((state: RootState) => state.content.verified);
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );

  // If the user has not upload their data, redirect to the dashboard and if user is not verified, revoke access to the messages
  if (!account_profile.name) {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise, render the children
  return <>{children}</>;
};

export default ProtectedRoute;

export const ProtectedRepresentativeRoute: React.FC<ProtectedRouteProps> = ({
  children,
}) => {
  // Access isVerified from the Redux store
  const verified = useSelector((state: RootState) => state.content.verified);

  // Redirect to the dashboard and if user is not verified, revoke access to the messages

  if (!verified) {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise, render the children
  return <>{children}</>;
};
